//============================================================================
// Name        : EditScheduleWrapper.tsx
// Purpose     : Implement Scheduling UI wrapper
// Created     : 2019-08-16
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { jsx } from "@emotion/core";
import React from "react";
import { Provider } from "react-redux";
import EditSchedule from "./EditSchedule";
import editScheduleStore from "./scheduleStore";
import { IEditScheduleState } from "./types";

class EditScheduleWrapper extends React.Component<IEditScheduleState> {
   render() {
        return (
            <Provider store={editScheduleStore}>
                <EditSchedule {...this.props} />
            </Provider>
        );
    }
}

export default EditScheduleWrapper;
